import cmsData from './common';

export default cmsData;
